import { render, staticRenderFns } from "./Saving.vue?vue&type=template&id=44257076&scoped=true"
import script from "./Saving.vue?vue&type=script&lang=js"
export * from "./Saving.vue?vue&type=script&lang=js"
import style0 from "./Saving.vue?vue&type=style&index=0&id=44257076&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44257076",
  null
  
)

export default component.exports